import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./addNewBook.scss";
import Navbar from "../../components/navbar/Navbar";
import { CloudUpload, Add, Save, Cancel } from "@mui/icons-material";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Chip,
  styled,
  Paper,
  Typography,
  Backdrop,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Box,
  Container,
  Stack,
  Select,
  InputLabel,
} from "@mui/material";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db, realtimeDB, storage } from "../../firebase";
import { generateKeywords } from "../../functions";
import {
  getDownloadURL,
  ref as storageRef,
  uploadBytes,
} from "firebase/storage";
import { handleInputNumber } from "../../context/commonFunctions";
import { useUserData } from "../../context/UserContext";
import { child, get, ref as realtimeRef } from "firebase/database";

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const publisherID = localStorage.getItem("publisherID");

function AddNewBook() {
  const { userData } = useUserData();
  const [radioTypeValue, setRadioTypeValue] = useState("book");
  const [radioPaymentValue, setRadioPaymentValue] = useState("paid");
  const [categories, setCategories] = useState({});
  const [categoryArray, setCategoryArray] = useState([]);
  const [subCategoryArray, setSubCategoryArray] = useState([]);
  const [categoryVlaue, setCategoryValue] = useState("");
  const [subCategoryValue, setSubCategoryValue] = useState("");
  const [tagData, setTagData] = useState([]);
  const [tagServerData, setTagServerData] = useState([]);
  const [image, setImage] = useState(null);
  const [samplePdf, setSamplePdf] = useState(null);
  const [mainPdf, setMainPdf] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    about: "",
    author: "",
    publisher: "",
    discount: 0,
    price: 0,
    isbn: "",
    language: "",
    pdf_password: "",
    pages: 0,
  });
  const [formErrors, setFormErrors] = useState({
    name: "",
    about: "",
    author: "",
    publisher: "",
    discount: "",
    price: "",
    isbn: "",
    language: "",
    pdf_password: "",
    pages: "",
  });
  const [open, setOpen] = useState(false);

  const [docRef, setDocRef] = useState(null);
  const [loadingDialogMessage, setLoadingDialogMessage] =
    useState("Please wait...");
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Wishallbook - Add Book";

    const fetchData = async () => {
      //categories
      const catRef = realtimeRef(realtimeDB);
      get(child(catRef, "categories"))
        .then((snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.val();
            setCategories(data);
          } else {
            console.log("No category available");
          }
        })
        .catch((error) => {
          console.error(error);
        });
      //tags
      try {
        const documentRef = doc(db, "Alphabet", "home");
        const snapshot = await getDoc(documentRef);
        const tags = snapshot.data().tags;
        setTagServerData(tags);
      } catch (error) {
        console.error("Error fetching data from Firestore:", error);
      }
    };

    fetchData();
  }, []);
  const validateForm = () => {
    const errors = {
      name: "",
      about: "",
      author: "",
      publisher: "",
      discount: "",
      price: "",
      isbn: "",
      language: "",
      pdf_password: "",
      pages: "",
    };

    let isValid = true;

    if (!formData.name.trim()) {
      errors.name = "Book Name cannot be empty";
      isValid = false;
    }
    if (!formData.about.trim()) {
      errors.about = "About cannot be empty";
      isValid = false;
    }
    if (!formData.author.trim()) {
      errors.author = "Author Name cannot be empty";
      isValid = false;
    }

    if (!formData.discount) {
      errors.discount = "Discount cannot be empty";
      isValid = false;
    }
    if (!formData.price || formData.price === 0) {
      errors.price = "Price cannot be empty/zero";
      isValid = false;
    }
    if (!formData.isbn.trim()) {
      errors.isbn = "ISBN No. cannot be empty";
      isValid = false;
    }
    if (!formData.language.trim()) {
      errors.language = "Language cannot be empty";
      isValid = false;
    }
    if (!formData.pdf_password.trim()) {
      errors.pdf_password = "PDF Password cannot be empty";
      isValid = false;
    }
    if (!formData.pages || formData.pages === 0) {
      errors.pages = "PDF Pages cannot be empty/zero";
      isValid = false;
    }
    let alertMessage = "Validation Error:\n";

    if (!categoryVlaue.trim()) {
      isValid = false;
      alertMessage += "- Category selection is required.\n";
    }

    if (tagData.length === 0) {
      isValid = false;
      alertMessage +=
        "- Please add at least one tag for better categorization.\n";
    }

    if (image === null) {
      isValid = false;
      alertMessage += `- It's necessary to upload a cover image for your ${radioTypeValue} to enhance visibility.\n`;
    }

    if (samplePdf === null) {
      isValid = false;
      alertMessage +=
        "- Kindly select and upload a sample PDF file for preview purposes.\n";
    }

    if (mainPdf === null) {
      isValid = false;
      alertMessage +=
        "- Upload the main PDF file to provide the complete document.\n";
    }

    if (!isValid) {
      alert(alertMessage);
    }

    setFormErrors(errors);

    return isValid;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const nameSearchArray = generateKeywords(formData.name);
    const authorSearchArray = generateKeywords(formData.author);
    const publisherSearchArray = generateKeywords(formData.publisher);
    const categorySearchArray = generateKeywords(categoryVlaue);
    const subCategorySearchArray = generateKeywords(subCategoryValue);

    var tagsSearchArray = [];
    tagData.forEach(
      (tag) =>
        (tagsSearchArray = [...tagsSearchArray, ...generateKeywords(tag)])
    );

    if (validateForm()) {
      var mapData = formData;
      mapData = {
        ...mapData,
        category: categoryVlaue,
        subCategory: subCategoryValue,
        unitSold: 0,
        publish_on: serverTimestamp(),
        publisherID: publisherID,
        searchKeywords: [
          ...nameSearchArray,
          ...authorSearchArray,
          ...publisherSearchArray,
          ...categorySearchArray,
          ...subCategorySearchArray,
          ...tagsSearchArray,
        ],
        tags: tagData,
        payment_type:
          radioPaymentValue.charAt(0).toUpperCase() +
          radioPaymentValue.slice(1),
        eType: radioTypeValue.charAt(0).toUpperCase() + radioTypeValue.slice(1),
      };
      setOpen(true);
      setLoadingDialogMessage("Uploading book data...");

      try {
        const documentRef = await addDoc(
          collection(db, "pendingBooks"),
          mapData
        );
        setDocRef(documentRef);
        console.log("Document written with ID: ");
      } catch (error) {
        setOpen(false);
        alert("Error uploading document: " + error);
      }
    } else {
      console.log("Form is not valid, do not submit");
    }
  };
  useEffect(() => {
    if (docRef) {
      uploadFilesToStorage(docRef);
    }
  }, [docRef]);

  useEffect(() => {
    setFormData({ ...formData, publisher: userData.fullName });
  }, [userData]);
  useEffect(() => {
    setCategoryArray(categories);
  }, [categories]);

  const uploadFilesToStorage = async (documentRef) => {
    let pdfFileUrls = {};
    setLoadingDialogMessage("Performing assets upload...");

    const coverImgRef = storageRef(
      storage,
      "files/" + documentRef.id + "/cover_image.jpg"
    );
    const samplePDFRef = storageRef(
      storage,
      "files/" + documentRef.id + "/sample_" + documentRef.id + ".pdf"
    );
    const mainPDFRef = storageRef(
      storage,
      "files/" + documentRef.id + "/" + documentRef.id + ".pdf"
    );
    setLoadingDialogMessage("Cover Image uploading...");

    uploadBytes(coverImgRef, image)
      .then((snapshot) => {
        getDownloadURL(snapshot.ref).then((url) => {
          pdfFileUrls.coverImage = url;
          pdfFileUrls.thumbImage = url;
          setLoadingDialogMessage("PDF's uploading...");

          uploadBytes(samplePDFRef, samplePdf)
            .then((snapshot1) => {
              getDownloadURL(snapshot1.ref).then((url1) => {
                pdfFileUrls.samplePdfUrl = url1;
                uploadBytes(mainPDFRef, mainPdf)
                  .then((snapshot2) => {
                    getDownloadURL(snapshot2.ref).then(async (url2) => {
                      pdfFileUrls.pdfUrl = url2;

                      const bookRef = doc(db, "pendingBooks", documentRef.id);
                      try {
                        await updateDoc(bookRef, pdfFileUrls);
                        setOpen(false);
                        navigate("/pending-books");
                      } catch (error) {
                        alert(error);
                      }
                    });
                  })
                  .catch((error) => {
                    alert(error);
                  });
              });
            })
            .catch((error) => {
              alert(error);
            });
        });
      })
      .catch((error) => {
        alert(error);
      });
  };

  const addTag = (newTag) => {
    if (!tagData.includes(newTag)) {
      setTagData((prevTags) => [...prevTags, newTag]);
    }
  };

  const handleSamplePDFChange = (e) => {
    const selectedPdf = e.target.files[0];

    if (selectedPdf && selectedPdf.type === "application/pdf") {
      setSamplePdf(selectedPdf);
    } else {
      alert("Please select a valid PDF file.");
    }
  };
  const handleMainPDFChange = (e) => {
    const selectedPdf = e.target.files[0];

    if (selectedPdf && selectedPdf.type === "application/pdf") {
      setMainPdf(selectedPdf);
    } else {
      alert("Please select a valid PDF file.");
    }
  };

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    // Check if the selected file is an image
    if (selectedImage && selectedImage.type.startsWith("image/")) {
      setImage(selectedImage);
    } else {
      alert("Please select a valid image file.");
    }
  };

  const handleDeleteTag = (tagToRemove) => () => {
    setTagData((prevTags) => prevTags.filter((tag) => tag !== tagToRemove));
  };

  const handleRadioType = (event) => {
    setRadioTypeValue(event.target.value);
  };
  const handleRadioPaymentMode = (event) => {
    setRadioPaymentValue(event.target.value);
  };
  return (
    <>
      <Navbar />
      <div className="addNewbook">
        <Container maxWidth="xl" sx={{ py: 3 }}>
          {/* Header */}
          <Card elevation={2} sx={{ mb: 3 }}>
            <CardHeader
              title={
                <Box display="flex" alignItems="center" gap={1}>
                  <Add color="primary" />
                  <Typography variant="h5" component="h1">
                    Add New Book
                  </Typography>
                </Box>
              }
              subheader="Create a new book entry for your library"
            />
          </Card>

          <Grid container spacing={3}>
            {/* Left Panel - Media Upload */}
            <Grid item xs={12} md={4} sx={{ order: { xs: 1, md: 1 } }}>
              <Card
                elevation={2}
                sx={{
                  height: "fit-content",
                  position: { xs: "static", md: "sticky" },
                  top: 20,
                }}
              >
                <CardHeader title="Media Files" />
                <CardContent>
                  <Stack spacing={3} alignItems="center">
                    {/* Book Cover */}
                    <Box>
                      <Typography variant="subtitle2" gutterBottom>
                        Book Cover *
                      </Typography>
                      <Box
                        sx={{
                          width: { xs: 150, sm: 180, md: 200 },
                          height: { xs: 200, sm: 240, md: 280 },
                          border: image
                            ? "2px solid #4caf50"
                            : "2px dashed #e0e0e0",
                          borderRadius: 2,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          mb: 2,
                          position: "relative",
                          backgroundColor: image ? "transparent" : "#f5f5f5",
                          mx: "auto",
                          "&:hover": {
                            borderColor: "primary.main",
                            backgroundColor: image
                              ? "transparent"
                              : "action.hover",
                          },
                        }}
                      >
                        <img
                          src={
                            image
                              ? URL.createObjectURL(image)
                              : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                          }
                          alt="Book cover"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 8,
                          }}
                        />
                      </Box>
                      <Button
                        component="label"
                        variant={image ? "contained" : "outlined"}
                        startIcon={<CloudUpload />}
                        fullWidth
                        size="small"
                        color={image ? "success" : "primary"}
                      >
                        {image ? "Change Cover" : "Upload Cover"}
                        <VisuallyHiddenInput
                          type="file"
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                      </Button>
                    </Box>

                    <Divider sx={{ width: "100%" }} />

                    {/* Sample PDF */}
                    <Box sx={{ width: "100%" }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Sample PDF *
                      </Typography>
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 2,
                          mb: 1,
                          backgroundColor: samplePdf
                            ? "success.light"
                            : "grey.50",
                          color: samplePdf
                            ? "success.contrastText"
                            : "text.secondary",
                          border: samplePdf
                            ? "1px solid #4caf50"
                            : "1px solid #e0e0e0",
                        }}
                      >
                        <Typography variant="body2" noWrap>
                          {samplePdf
                            ? `✓ ${samplePdf.name}`
                            : "No sample PDF selected"}
                        </Typography>
                      </Paper>
                      <Button
                        component="label"
                        variant={samplePdf ? "contained" : "outlined"}
                        startIcon={<CloudUpload />}
                        fullWidth
                        size="small"
                        color={samplePdf ? "success" : "primary"}
                      >
                        {samplePdf ? "Change Sample" : "Upload Sample"}
                        <VisuallyHiddenInput
                          type="file"
                          accept=".pdf"
                          onChange={handleSamplePDFChange}
                        />
                      </Button>
                    </Box>

                    {/* Main PDF */}
                    <Box sx={{ width: "100%" }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Main PDF *
                      </Typography>
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 2,
                          mb: 1,
                          backgroundColor: mainPdf
                            ? "success.light"
                            : "grey.50",
                          color: mainPdf
                            ? "success.contrastText"
                            : "text.secondary",
                          border: mainPdf
                            ? "1px solid #4caf50"
                            : "1px solid #e0e0e0",
                        }}
                      >
                        <Typography variant="body2" noWrap>
                          {mainPdf
                            ? `✓ ${mainPdf.name}`
                            : "No main PDF selected"}
                        </Typography>
                      </Paper>
                      <Button
                        component="label"
                        variant={mainPdf ? "contained" : "outlined"}
                        startIcon={<CloudUpload />}
                        fullWidth
                        size="small"
                        color={mainPdf ? "success" : "primary"}
                      >
                        {mainPdf ? "Change Main PDF" : "Upload Main PDF"}
                        <VisuallyHiddenInput
                          type="file"
                          accept=".pdf"
                          onChange={handleMainPDFChange}
                        />
                      </Button>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
            {/* Right Panel - Form */}
            <Grid item xs={12} md={8} sx={{ order: { xs: 2, md: 2 } }}>
              <Stack spacing={3}>
                {/* Basic Information */}
                <Card elevation={2}>
                  <CardHeader title="Basic Information" />
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Book Name"
                          placeholder="Enter the book title"
                          onChange={(e) => {
                            setFormData({ ...formData, name: e.target.value });
                          }}
                          error={formErrors.name !== ""}
                          helperText={formErrors.name}
                          variant="outlined"
                          required
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="About"
                          placeholder="Describe the book content, themes, and target audience"
                          multiline
                          rows={4}
                          onChange={(e) => {
                            setFormData({ ...formData, about: e.target.value });
                          }}
                          error={formErrors.about !== ""}
                          helperText={formErrors.about}
                          variant="outlined"
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Author Name"
                          placeholder="Enter author's full name"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              author: e.target.value,
                            });
                          }}
                          error={formErrors.author !== ""}
                          helperText={formErrors.author}
                          variant="outlined"
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Publisher"
                          value={userData.fullName}
                          disabled
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Language"
                          placeholder="e.g., English, Hindi, etc."
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              language: e.target.value,
                            });
                          }}
                          error={formErrors.language !== ""}
                          helperText={formErrors.language}
                          variant="outlined"
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="ISBN No."
                          placeholder="International Standard Book Number"
                          onChange={(e) => {
                            setFormData({ ...formData, isbn: e.target.value });
                          }}
                          error={formErrors.isbn !== ""}
                          helperText={formErrors.isbn}
                          variant="outlined"
                          required
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                {/* Pricing & Details */}
                <Card elevation={2}>
                  <CardHeader title="Pricing & Details" />
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Price"
                          placeholder="0"
                          onInput={handleInputNumber}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                ₹
                              </InputAdornment>
                            ),
                          }}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              price: parseInt(e.target.value, 10) || 0,
                            });
                          }}
                          error={formErrors.price !== ""}
                          helperText={formErrors.price}
                          variant="outlined"
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Discount"
                          placeholder="0"
                          onInput={handleInputNumber}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">%</InputAdornment>
                            ),
                          }}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              discount: parseInt(e.target.value, 10) || 0,
                            });
                          }}
                          error={formErrors.discount !== ""}
                          helperText={formErrors.discount}
                          variant="outlined"
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="PDF Password"
                          placeholder="Password to protect the PDF"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              pdf_password: e.target.value,
                            });
                          }}
                          error={formErrors.pdf_password !== ""}
                          helperText={formErrors.pdf_password}
                          variant="outlined"
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="PDF Pages"
                          placeholder="Total number of pages"
                          onInput={handleInputNumber}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              pages: parseInt(e.target.value, 10) || 0,
                            });
                          }}
                          error={formErrors.pages !== ""}
                          helperText={formErrors.pages}
                          variant="outlined"
                          required
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                {/* Categories & Tags */}
                <Card elevation={2}>
                  <CardHeader title="Categories & Tags" />
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          select
                          label="Category"
                          placeholder="Select a category"
                          onChange={(e) => {
                            setCategoryValue(categories[e.target.value].title);
                            setSubCategoryArray(
                              categories[e.target.value].subCategories
                            );
                          }}
                          variant="outlined"
                          required
                        >
                          {Object.keys(categoryArray).map((category) => (
                            <MenuItem key={category} value={category}>
                              {categoryArray[category].title}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      {subCategoryArray.length !== 0 && (
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            select
                            label="Sub Category"
                            placeholder="Select a subcategory"
                            onChange={(e) => {
                              setSubCategoryValue(e.target.value);
                            }}
                            variant="outlined"
                          >
                            {subCategoryArray.map((subCategory) => (
                              <MenuItem key={subCategory} value={subCategory}>
                                {subCategory}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="tags-select-label">Tags</InputLabel>
                          <Select
                            labelId="tags-select-label"
                            id="tags-select"
                            value={""}
                            label="Tags"
                            onChange={(e) => {
                              const newTag = e.target.value;
                              addTag(newTag.toLowerCase());
                            }}
                          >
                            {tagServerData.map((value) => (
                              <MenuItem key={value} value={value}>
                                {value}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      {tagData.length > 0 && (
                        <Grid item xs={12}>
                          <Typography variant="subtitle2" gutterBottom>
                            Current Tags:
                          </Typography>
                          <Paper
                            variant="outlined"
                            sx={{
                              p: 1,
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 1,
                              minHeight: 50,
                              alignItems: "flex-start",
                              alignContent: "flex-start",
                            }}
                          >
                            {tagData.map((data) => (
                              <Chip
                                key={data}
                                label={data}
                                onDelete={handleDeleteTag(data)}
                                color="primary"
                                variant="outlined"
                                size="small"
                              />
                            ))}
                          </Paper>
                        </Grid>
                      )}
                    </Grid>
                  </CardContent>
                </Card>
                {/* Settings */}
                <Card elevation={2}>
                  <CardHeader title="Settings" />
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Content Type</FormLabel>
                          <RadioGroup
                            row
                            value={radioTypeValue}
                            onChange={handleRadioType}
                            sx={{ mt: 1 }}
                          >
                            <FormControlLabel
                              value="book"
                              control={<Radio />}
                              label="Book"
                            />
                            <FormControlLabel
                              value="notes"
                              control={<Radio />}
                              label="Notes"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Payment Mode</FormLabel>
                          <RadioGroup
                            row
                            value={radioPaymentValue}
                            onChange={handleRadioPaymentMode}
                            sx={{ mt: 1 }}
                          >
                            <FormControlLabel
                              value="paid"
                              control={<Radio />}
                              label="Paid"
                            />
                            <FormControlLabel
                              value="free"
                              control={<Radio />}
                              label="Free"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                {/* Action Buttons */}
                <Card elevation={2}>
                  <CardContent>
                    <Stack
                      direction="row"
                      spacing={2}
                      justifyContent="flex-end"
                    >
                      <Button
                        variant="outlined"
                        startIcon={<Cancel />}
                        onClick={() => navigate(-1)}
                        size="large"
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        startIcon={<Save />}
                        onClick={handleSubmit}
                        size="large"
                        sx={{ minWidth: 120 }}
                      >
                        Submit Book
                      </Button>
                    </Stack>
                  </CardContent>
                </Card>
              </Stack>
            </Grid>
          </Grid>
        </Container>

        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Card sx={{ p: 3, textAlign: "center", minWidth: 300 }}>
            <CircularProgress size={60} sx={{ mb: 2 }} />
            <Typography variant="h6" gutterBottom>
              {loadingDialogMessage}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Please wait while we process your book
            </Typography>
          </Card>
        </Backdrop>
      </div>
    </>
  );
}

export default AddNewBook;
